/* eslint-disable no-new */
import Vue from 'vue/dist/vue.esm';
import VueResource from 'vue-resource';
import dayjs from 'dayjs/esm';
import uniqBy from 'lodash/uniqBy';
import JsonApiUrl from '../../00-foundation/00-utils/json-api-endpoint';
import { EventBus, requestHeaders } from '../../configuration';

const urlBuilder = new JsonApiUrl.Builder('node', 'blog')
  .withIncludes([
    'field_categories_blog',
    'field_category_technologies',
    'field_image_teaser',
    'field_image_teaser.field_media_image',
  ])
  .withFields({
    media__image: ['field_media_image'],
    file__file: ['url', 'uri'],
  })
  .sortBy(['-created', 'title'])
  .paginate(6)
  .aliased(true);

/* global drupalSettings */
if (typeof drupalSettings !== 'undefined' && drupalSettings.path !== 'undefined') {
  const { currentLanguage } = drupalSettings.path;
  if (currentLanguage) {
    urlBuilder.filterByLanguage(currentLanguage);
  }
}
const blogEndPoint = urlBuilder.build().toString();

Vue.use(VueResource);
[...document.querySelectorAll('[data-component="blog-feed"]')].forEach(el => {
  new Vue({
    el,
    data() {
      return {
        modifiedData: [],
        items: [],
        loadMoreIsDisabled: false,
        selectedCategory: 'all',
      };
    },

    methods: {
      getItemLink(item) {
        if (item.attributes.path && item.attributes.path.alias) {
          return item.attributes.path.alias;
        }
        if (item.attributes.alias) {
          return item.attributes.alias;
        }
        return `/node/${item.attributes.drupal_internal__nid}`;
      },

      getImageTeaserInformation(item) {
        const imageId = item.relationships.field_image_teaser.data && item.relationships.field_image_teaser.data.id;

        const imageData = {};

        const imageTeaserData = this.included.filter(itemData => {
          return itemData.id === imageId;
        })[0];

        const fileTeaserData = this.included.filter(fileData => {
          return fileData.id === imageTeaserData.relationships.field_media_image.data.id;
        })[0];

        if (
          fileTeaserData &&
          fileTeaserData.links &&
          fileTeaserData.links.blog_teaser_focal_point_ && // eslint-disable-line no-underscore-dangle
          fileTeaserData.links.blog_teaser_focal_point_.href // eslint-disable-line no-underscore-dangle
        ) {
          // eslint-disable-next-line no-underscore-dangle
          imageData.url = fileTeaserData.links.blog_teaser_focal_point_.href;
        }
        if (imageTeaserData && imageTeaserData.relationships.field_media_image.data.meta.alt) {
          imageData.alt = imageTeaserData.relationships.field_media_image.data.meta.alt;
        }

        return imageData;
      },

      formatDate(date) {
        return dayjs(date).format('D MMMM YYYY');
      },

      getBlogCategories(item) {
        const data = [];
        item.relationships.field_categories_blog.data.map(category => {
          this.included.map(inc => {
            if (inc.id === category.id) {
              data.push(inc);
            }
            return inc;
          });
          return category;
        });
        return uniqBy(data, 'id');
      },

      categoryClicked(cat) {
        EventBus.$emit('categorySelected', cat);
        window.scrollTo(0, 0);
      },

      processData(data) {
        data.forEach(item => {
          this.modifiedData.push({
            ...item,
            link: this.getItemLink(item),
            imageTeaser: this.getImageTeaserInformation(item),
            date: this.formatDate(item.attributes.created),
            categories: this.getBlogCategories(item),
          });
        });
      },

      loadItems() {
        this.loadMoreIsDisabled = false;
        this.items = this.modifiedData;
        if (!this.links.next) {
          this.loadMoreIsDisabled = true;
        }
      },

      loadMoreItems() {
        if (!this.loadMoreIsDisabled && this.links.next) {
          // could trigger loader here too
          this.loadMoreIsDisabled = true;
          this.$http
            .get(this.links.next.href.replace('http://', 'https://'), { requestHeaders })
            .then(response => {
              this.included = [...this.included, ...response.body.included];
              this.links = response.body.links;
              this.processData(response.body.data);
              this.loadItems();
            })
            .catch(err => console.log(err)); // eslint-disable-line no-console
        }
      },

      getPostsByCat() {
        const endpoint =
          this.selectedCategory === 'all' || !this.selectedCategory
            ? blogEndPoint
            : `${blogEndPoint}&filter[field_categories_blog.id][value]=${this.selectedCategory}`;

        this.$http.get(endpoint, { requestHeaders }).then(response => {
          // reset data
          this.items = [];
          this.modifiedData = [];

          this.included = response.body.included;
          this.links = response.body.links;
          this.processData(response.body.data);
          this.loadItems();
        });
      },
    },

    mounted() {
      this.$http.get(blogEndPoint, { requestHeaders }).then(response => {
        this.included = response.body.included;
        this.links = response.body.links;
        this.processData(response.body.data);
        this.loadItems();
      });
    },

    created() {
      EventBus.$on('categorySelected', cat => {
        this.selectedCategory = cat;
        this.getPostsByCat();
      });
    },
  });
});
